<div class="phone-input" [ngClass]="{ 'phone-input--fullsize': type === 'country', 'phone-input--active': active, 'phone-input--disabled': disabled, 'phone-input--error': error }">
  <div class="phone-input__inner">
    <div class="phone-input__selected" (click)="toggle()">
      @if (value) {
        <div class="phone-input__value">
          <app-image [src]="ssrService.isServer() ? 'images/flags/cz.svg' : value.image" [alt]="value.name" [optimized]="false" [width]="24" [height]="24"></app-image>
          @if (search) {
            <input #searchInput id="form-id-phone-input" class="phone-input__search" name="phone-input-country-code" type="text" [(ngModel)]="searchValue" (input)="searchValueChange()" (focusout)="searchValueFocusout()" />
          } @else {
            {{ type === 'phone' ? value.dialCode : value.name }}
          }
        </div>
      }
    </div>
    @if (preferredCountries || countries) {
      <div class="phone-input__dropdown" [ngClass]="{ 'phone-input__dropdown--active': active }">
        @if (type === 'country') {
          <ul class="phone-input__list">
            <li class="phone-input__list-item" (click)="select(undefined)">--- {{ 'globals.select' | translate }} ---</li>
          </ul>
        }
        @if (preferredCountries.length) {
          <ul class="phone-input__list phone-input__list--prefered">
            @for (country of preferredCountries; track country.code) {
              <li class="phone-input__list-item" (click)="select(country)">
                <app-image [src]="country.image" [alt]="country.name" [optimized]="false" [width]="24" [height]="24"></app-image>
                {{ country.name }}
                @if (type === 'phone') {
                  <span class="phone-input__list-code">{{ country.dialCode }}</span>
                }
              </li>
            }
          </ul>
        }
        <ul class="phone-input__list">
          @for (country of countries; track country.code) {
            @if (country.visible !== false) {
              <li class="phone-input__list-item" (click)="select(country)">
                <app-image [src]="country.image" [alt]="country.name" [optimized]="false" [width]="24" [height]="24"></app-image>
                {{ country.name }}
                @if (type === 'phone') {
                  <span class="phone-input__list-code">{{ country.dialCode }}</span>
                }
              </li>
            }
          }
        </ul>
      </div>
    }
  </div>
  @if (error) {
    <div class="input__info">
      <app-input-error class="input__error">
        {{ errorMessage ?? 'forms.inputError' | translate }}
      </app-input-error>
    </div>
  }
</div>
